import React, { useEffect } from 'react';
import { Box, DialogContent, DialogTitle } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { BasicDataTypes } from '../../types/types';
import { useLocationRequest } from '../../hooks/locationRequest';

interface FormData {
  name: string;
}

interface UpdateLocationProps {
  setDialogOpen: (open: boolean) => void;
  locationData: BasicDataTypes;
}

const validationSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
});

const UpdateLocation: React.FC<UpdateLocationProps> = ({ setDialogOpen, locationData }) => {
  const locationRequest = useLocationRequest();
  const { control, handleSubmit, setValue, formState: { errors } } = useForm<FormData>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      name: locationData.name,
    },
  });

  const onSubmit = async (data: FormData) => {
    try {
      const dispatchData = await locationRequest({ method: 'PUT', data: data, slug: locationData.slug, query: null });
      if (dispatchData.meta.requestStatus === 'fulfilled') {
        setDialogOpen(false);
        await locationRequest({ method: 'GET', data: null, slug: null, query: null });
      }
    } catch (error) {
      console.error('Failed to update location:', error);
    }
  };

  useEffect(() => {
    setValue('name', locationData.name);
  }, [locationData, setValue]);

  return (
    <DialogContent>
      <DialogTitle sx={{ p: 0 }}>Update Location</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              autoFocus
              sx={{ width: 300 }}
              {...field}
              label="Name"
              variant="standard"
              error={!!errors.name}
              helperText={errors.name ? errors.name.message : ''}
              fullWidth
              margin="normal"
            />
          )}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
          <Button sx={{ mr: 2 }} onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            Save
          </Button>
        </Box>
      </form>
    </DialogContent>
  );
};

export default UpdateLocation;
